<template>
	<div>
		<div :class="'box_container ' +$route.name">
			<h1 class="title" >MASS WEB WALLET
        <span class="bg_title">MASS WEB WALLET</span>
      </h1>
			<div class="content">
				<router-view></router-view>
			</div>
		</div>
		<div class="background"></div>
	</div>
</template>
<script>
export default {
  mounted(){
   const lang = this.$route.query.lang
    if(lang && lang != 'zh') {
      this.$i18n.locale = 'en-US'
      localStorage.setItem("MASSWALLETLOCALE",  this.$i18n.locale);
    } else if (lang){
      this.$i18n.locale = 'zh-CN'
      localStorage.setItem("MASSWALLETLOCALE",  this.$i18n.locale);
    }
   
  }
}
</script>
<style lang="scss" scoped>
.box_container{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .title{
    font-size: 3.2rem;
    font-weight: bolder;
    color: #FFFFFF;
    line-height: 3.9rem;
    text-align: center;
    margin-bottom: 4.1rem;
    font-style: oblique;
    position: relative;
    z-index: 9;
    .bg_title {
      font-size: 2em;
        position: relative;
        display: block;
        top: -65%;
        z-index: -1;
        -webkit-text-stroke: 1px #fff;
        opacity: .2;
        -webkit-text-fill-color: #f00;
    }
  }
  .content{
    background: #FFFFFF;
    border-radius: .6rem;
    padding: 4.2rem;
    width: 43.5rem;
    min-height: 30rem;
  }
}
.background{
  position: absolute;
  top: 0;
  left: 50%;
  z-index: -1;
  width: 100%;
  height: 50%;
  user-select: none;
  transform: translateX(-50%);
  background: var(--main-color);
  background-size: 100% auto;
}
@media screen and (max-width: 768px){

    .background{
        display: none;
      }
  .box_container{
    display: block;
    .title{
      display: none;
      .bg_title{
       display: none;
    }
    }
    
    .content {
      height: auto;
      width: 100%;
      border: none;
      padding: 4.2rem 1.6rem;
      background: none;
    }
    &.login, &.register,&.forget{
      
      .title{
        display: block;
        width: 100%;
        // align-self: stretch;
        background: #DC472A;
        padding: 12vh 0;
        margin-bottom: 0;
      }
    }
  }
}
</style>